module.exports = __webpack_public_path__ + "img/Frame 1040one.7449b649.png";